import { deepFreeze } from "@/utils/ObjectUtils";

function mapModules(region, hits) {
  return hits.map(hit => deepFreeze(hit));
}

export { mapModules };
